import { Box } from "@mui/material"
import EmailLogList from "@pages/main/email_logs/sub_components/EmailLogList"

export default function EmailLogsPage() {
  // const [selectedEmailSid, setSelectedEmailSid] = useState<string | null>(null)

  /* const handleSelectEmail = (callSid: string) => {
    setSelectedEmailSid(callSid)
  } */

  return (
    <Box sx={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      <Box
        sx={{
          flex: 1,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <EmailLogList /* onSelectEmail={handleSelectEmail}*/ />
      </Box>
    </Box>
  )
}
